import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ManufacturerService } from 'src/app/manufacturer/manufacturer.service';
import { CarModelService } from 'src/app/car-model/car-model.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CreateCarModelComponent } from '../create-car-model/create-car-model.component';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/redux/app.state';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { CarModel, Manufacturer } from 'src/typings';

@Component({
  selector: 'app-car-model-list',
  templateUrl: './car-model-list.component.html',
  styleUrls: ['./car-model-list.component.scss']
})
export class CarModelListComponent {
  displayedColumns: string[] = ['id', 'description', 'body', 'date_from', 'date_to'];

  modelList: CarModel[] = [];

  modelListFiltered = new MatTableDataSource<CarModel>();

  manufacturer: Manufacturer | undefined;

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  constructor(
    private carModelService: CarModelService,
    private activatedRoute: ActivatedRoute,
    private manufacturerService: ManufacturerService,
    private dialog: MatDialog,
    private store: Store<AppState>
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.loadModels(params.id);
      this.manufacturerService
        .search({
          id: params.id
        })
        .subscribe((result) => {
          this.manufacturer = result.data[0];
        });
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.modelListFiltered.data = this.modelList.filter((row) => {
      return row.description.toUpperCase().includes(filterValue.toUpperCase());
    });
  }

  add() {
    const dialogRef = this.dialog.open(CreateCarModelComponent);
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.componentInstance.manufacturer = this.manufacturer;
    dialogRef.componentInstance.modelCreateEvent.subscribe(() => {
      if (this.manufacturer) this.loadModels(this.manufacturer.id);
    });
  }

  loadModels(manufacturer_id: number) {
    this.loading = true;
    this.carModelService
      .search({
        manufacturer_id
      })
      .subscribe((list) => {
        this.loading = false;
        this.modelList = list.data;
        this.modelListFiltered.data = list.data;
        // if (list.data.length > 0) this.carModelControl?.setValue(list.data[0]);
      });
  }
}
